import React, { Suspense } from 'react';

import type { SanityHomePageTwoUp } from '#/lib/sanity/queries/sections';
import { useMediaQuery } from '#/lib/useMatchMedia';
import { cn } from '#/lib/utils';
import { Headline } from '#/components/Headline';

import { Image } from '../Image';

const DesktopAnimation = React.lazy(() => import('./DesktopAnimation'));
const MobileAnimation = React.lazy(() => import('./MobileAnimation'));

export function HomePageTwoUp(props: SanityHomePageTwoUp) {
  const [matches, hasRun] = useMediaQuery({ screen: 'm' });
  const shouldShowDesktopMedia = matches && hasRun;
  return (
    <div className="bg-charcoal text-cloud">
      <div
        className={cn(
          'fade-in m:py-20 m:px-25 l:px-50 xl:px-80 m:bg-transparent pb-40',
        )}
      >
        <div className="mx-auto flex m:flex-row flex-col max-w-1500 items-center m:gap-20">
          <div
            className={cn(
              'two-up-content w-full m:w-[45%] l:w-[45%] max-w-400 m:max-w-[465px] mx-auto m:mx-0',
              'px-15 m:px-0 text-center m:text-left text-balance l:ml-[8%]',
            )}
          >
            <Headline
              value={props.headline}
              overline={props.overline}
              variant={4}
              highlightClass="text-electric"
              className="my-22 m:my-22"
            />
            <p
              className={cn(
                'text-body l:text-18 m:whitespace-pre-wrap !text-current',
              )}
            >
              {props.bodyCopy}
            </p>
          </div>
          <div className={cn('two-up-media w-full flex-1 max-w-[680px]')}>
            {shouldShowDesktopMedia ? (
              <div className="fade-in">
                <Suspense>
                  <DesktopAnimation
                    fallback={<Image sizes="100vw" image={props.media} />}
                  />
                </Suspense>
              </div>
            ) : (
              <div className="fade-in media flex-1">
                <Suspense>
                  <MobileAnimation
                    fallback={
                      <div className="media w-full aspect-square">
                        <Image sizes="100vw" image={props.mobileMedia} />
                      </div>
                    }
                  />
                </Suspense>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
